export default __webpack_public_path__ + "static/media/deni.6966803e.jpg";